import { importProvidersFrom, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IonicModule } from '@ionic/angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  AppInfoInterceptor,
  ENV_CONFIG,
  ErrorHandlerInterceptor,
  Logger,
  provideTranslation,
  provideTranslationDeps,
  TimezoneInterceptor,
  TraceRequestInterceptor,
  TraceSessionInterceptor
} from '@core';
import { environment } from '../environment/environment';
import { AuthInterceptor, AuthModule } from '@auth';
import { FeatureFlagHandler, LoadFeatureFlagsCommandHandler } from '@feature-flags';
import {
  NotificationObserverQueryHandler,
  NotificationsInitializer,
  PushPermissionsStatusCommandHandler,
  UpdateAlertsLocationCommandHandler
} from '@notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideSentry } from './sentry';
import { CreateGameViewService } from '../../projects/hosted-games/src/lib/application/view-services';
import { ChatInitializer, UnreadMessagesQueryHandler } from '@messages';
import { StreamI18nService } from 'stream-chat-angular';
import { SetFilterCommandHandler } from '../../projects/find-games/src/lib/application/handlers';
import { UserService } from '@profile/infra';
import {
  UpdateUserCommandHandler,
  UpdateUserLocationCommandHandler
} from '../../projects/profile/src/lib/application/handlers';
import { provideFirebase } from './firebase.config';
import { FeatureFlagsService, FeatureFlagsStorage } from '@feature-flags/infra';
import { DistanceFilterStorage, FiltersStorage } from '@find-games/infra';
import { ChatService, UnreadMessagesService } from '@messages/infra';
import { NotificationsAlertsService, NotificationsService } from '@notifications/infra';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [BrowserAnimationsModule, BrowserModule, AppRoutingModule, AuthModule],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    ...provideFirebase(),
    ...provideSentry(),
    provideTranslation(),
    ...provideTranslationDeps(),
    importProvidersFrom(IonicModule.forRoot({ mode: 'ios' })),
    ChatInitializer,
    StreamI18nService,
    ChatService,
    UnreadMessagesService,
    NotificationsInitializer,
    Logger,
    {
      provide: ENV_CONFIG,
      useValue: environment
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimezoneInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AppInfoInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TraceRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TraceSessionInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    },
    FeatureFlagsService,
    FeatureFlagsStorage,
    LoadFeatureFlagsCommandHandler,
    FeatureFlagHandler,
    NotificationsService,
    CreateGameViewService,
    UnreadMessagesQueryHandler,
    UpdateAlertsLocationCommandHandler,
    NotificationsAlertsService,
    PushPermissionsStatusCommandHandler,
    SetFilterCommandHandler,
    FiltersStorage,
    DistanceFilterStorage,
    NotificationObserverQueryHandler,
    UpdateUserCommandHandler,
    UpdateUserLocationCommandHandler,
    UserService
  ]
})
export class AppModule {}
